<template src="./form.html"></template>

<script>
import { CreateStudy, GetAssistItems } from '@/api/study'

export default {
  name: 'add-study',
  data: function () {
    return {
      model: {
        study_name: '',
        abbreviation: '',
        code: '',
        sponsor: '',
        description: '',
        phase: '',
        type: '',
        masking: '',
        random: '',
        sample: null,
        startdat: ''
      },
      types: {},
      maskings: {},
      randoms: {},
      phases: {},
      ruleValidate: {
        study_name: [{
          required: true,
          message: '必须填写研究名称',
          trigger: 'blur'
        }],
        abbreviation: [{
          required: true,
          message: '研究简称不能为空',
          trigger: 'blur'
        }],
        code: [{
          required: true,
          message: '研究代码不能为空',
          trigger: 'blur'
        }],
        sponsor: [{
          required: true,
          message: '申办方不能为空',
          trigger: 'blur'
        }],
        description: [{
          required: true,
          message: '研究描述不能为空',
          trigger: 'blur'
        }],
        phase: [{
          required: true,
          message: '研究分期不能为空',
          trigger: 'change'
        }],
        type: [{
          required: true,
          message: '研究对象种类不能为空',
          trigger: 'change'
        }],
        masking: [{
          required: true,
          message: '盲法不能为空',
          trigger: 'change'
        }],
        random: [{
          required: true,
          message: '随机方案不能为空',
          trigger: 'change'
        }]
      }
    }
  },
  created: function () {
    this.getItems()
  },
  methods: {
    getItems: function () {
      GetAssistItems().then(async res => {
        this.statuses = res.statuses
        this.types = res.types
        this.maskings = res.maskings
        this.randoms = res.randoms
        this.phases = res.phases
      })
    },
    handleSubmit: function (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.postForm()
        } else {
          this.$Message.error('信息填写有误!')
        }
      })
    },
    postForm: function () {
      CreateStudy(this.model).then(async res => {
        if (res.id) {
          this.$emit('refresh')
        }
      })
    }
  }
}
</script>
